/**
 * LastColor display tiles with last colors used by user.
 * This component can be build by a ModelArray or an object if you want to provide mode parameters.
 * Example : 
 * let element1 = new shared.panels.LastColor( this.data.customcolors );
 * let element2 = new shared.panels.LastColor( {data : this.data.customcolors, numberTiles : 10} );
 * 
 * By defaut this component displays only 5 color tiles.
 */
fx.ns("shared.panels", class LastColors extends fx.components.HBox {

    constructor(data)
    {
        super(data && data.data ? data.data : data);

        this._numberTiles = (data && data.numberTiles) ? data.numberTiles : 5;
        this._selectedElement;
    }

    get numberTiles()
    {
        return this._numberTiles;
    }

    set numberTiles(val)
    {
        this._numberTiles = val;

        this.update(true);
    }

    render()
    {
        let html = '';
        for (let i = 0; i < this.numberTiles && i < this.data.colors.length; i++)
            html += '<div class="tile" style="background-color:' + this.data.colors.getItemAt(i).color + '"></div>';
        
        return html;
    }

    onReady()
    {
        this.on("click", this.onClick);
    }

    contextMenu(e)
	{
        let menu = [];

        if(e)
        {
            if(e.target.className === "tile")
            {
                this._selectedElement = e.target;

                menu.push( {label : fx.text("Appliquer"), code : "apply"} );

                if (fx.get("app") != "frame")
                    menu.push( {label : fx.text("Appliquer à toutes les pages"), code : "applyall"} );
            }
        }
        return menu;
    }
    
	onContextMenu(e)
	{
		switch(e.detail.code)
		{
			case "apply":
					this.data.event("update-background-color",  this._selectedElement.style.backgroundColor);
				break;
			case "applyall":
					this.data.event("update-background-color-all",  this._selectedElement.style.backgroundColor);
				break;
		}
	}

    onClick(e)
    {
        let tile = fx.dom.parent(e.target, ".tile");
        if (tile)
        {
            let color = this.css(tile, "background-color");
            this.trigger("color", color);
        }
    }
});